/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P1_TInputs */

const en_mk_sec_pg_p1_t = /** @type {(inputs: Mk_Sec_Pg_P1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One company’s data stays enclosed`)
};

const id_mk_sec_pg_p1_t = /** @type {(inputs: Mk_Sec_Pg_P1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data satu perusahaan terkurung`)
};

/**
* | output |
* | --- |
* | "One company’s data stays enclosed" |
*
* @param {Mk_Sec_Pg_P1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p1_t = /** @type {((inputs?: Mk_Sec_Pg_P1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p1_t(inputs)
	return en_mk_sec_pg_p1_t(inputs)
});